/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Col_DateInputs */

const vi_reconcile_col_date = /** @type {(inputs: Reconcile_Col_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày giao dịch`)
};

/**

* @param {Reconcile_Col_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_col_date = /** @type {((inputs?: Reconcile_Col_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Col_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_col_date(inputs)
});